<template>
    <div class="w-full z-max animation-open bg-white min-h-full">
        <div class="vs-con-loading__container absolute h-full w-full z-max" v-show="onLoad" id="loading"></div>
        <div class="vs-row w-full header h-16 flex items-center ml-2">
            <div class="vs-col" @click="close">
                <feather-icon icon="ArrowLeftIcon" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-8 h-8"></feather-icon>
            </div>
            <div class="vs-col font-bold text-xl">
                <span>{{title}}</span>
            </div>
        </div>
        <div class="w-full lg:mx-auto md:w-full sm:w-full">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        onLoad: Boolean,
        redirectTo: String | Object
    },

    methods: {
        close () {
            this.$emit("input", false);
            if (this.redirectTo) {
                this.$router.push({path: this.redirectTo});
            }
        }
    },

    mounted () {
        this.$vs.loading({
            type: 'point',
            scale: '0.5',
            container: '#loading'
        });
        this.$emit("input", true);
    }
}
</script>

<style scoped>
    @keyframes open {
        from {
            margin-left: 100%;
        }

        to {
            margin-left: 0%;
        }
    }

    .animation-open {
        animation-name: open;
        animation-duration: 0.7s;
    }

    .z-max {
        z-index: 999999;
    }
</style>
